<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <bread-crumb></bread-crumb>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-upload2" class="s-btn-exp a-mlr-17" @click="exportfile">导出</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" id="leSearch">
                <le-select-remote-search label="电费项目"  v-model="pageParam.params.projectId" :options="optionsElectric" placeholder="请选择电费项目(可搜索)" />
                <le-select-remote-search label="电表号" v-model="pageParam.params.ammeterId" :options="optionsAmmeter" placeholder="请选择电表(可搜索)" />
                <le-select-remote-search label="站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择站点(可搜索)" />
                <le-date-range label="抄表时间" :minDate.sync="pageParam.params.startDate" :maxDate.sync="pageParam.params.endDate" />
            </le-search-form>
            <le-pagview 
                ref="electricStationListPage" 
                @setData="setTableData" 
                :pageParam="pageParam" 
                :isFixed="true" 
                :tableRef="$refs.electricStationList" >
                <el-table 
                    ref="electricStationList" 
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }" 
                    :span-method='mergeCols'
                    :border='true'
                    style="width: 100%">
                    <el-table-column prop="ammeterId" label="电表号" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.ammeterNo || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectId" label="电费项目" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.projectName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stationId" label="站点名称" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceNumId" label="设备总数/插槽总数" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.deviceNumByRadio || 0 }}/{{ row.slotNumByRadio || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastRecordTimeId" label="上次抄表时间" min-width="150">
                        <template slot-scope="{ row }">
                            <span>{{ row.lastRecordTime || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastRecordPowerId" label="上次度数（kwh）" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.lastRecordPower || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recordTimeId" label="本次抄表时间" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.recordTime || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recordPowerId" label="本次度数（kwh）" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.recordPower || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalPowerId" label="应结算度数（kwh）" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.intervalPower || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectId" label="应结算度数合计（kwh）" min-width="170">
                        <template slot-scope="{ row }">
                            <span>{{ row.cyIntervalPowerTotal || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPriceId" label="电费单价（/元/kwh）" min-width="160">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat5(row.unitPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="needPayAmountId" label="应付电费" min-width="140" v-if="chargeFeeType == 2">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.needPayAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectId" label="应付电费合计" min-width="140" v-if="chargeFeeType == 2">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.cyNeedPayAmountTotal) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalIncomeId" label="区间收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.intervalIncome) }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="lastRemainMoneyId" label="上期剩余费用" min-width="140" v-if="chargeFeeType == 1">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.lastRemainMoney) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gradeValueId" label="预付费用" min-width="140" v-if="chargeFeeType == 1">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.prePayAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalRatioId" label="区间电费占比" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.intervalRatio) }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalRatioId" label="项目总电费占比" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.totalRatio) }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="finalRemainMoneyId" label="费用结余预估" min-width="120" v-if="chargeFeeType == 1">
                        <template slot-scope="{ row }">
                            <span :class="finalRemainMoneyClass(row)">￥{{ util.numFormat(row.finalRemainMoney) }}{{ row.endDate?'（截止日期' + row.endDate + '）' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pid" label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <img src="../../assets/icon/option-refuse.png" class="a-wh-16" @click="electricBillDelete(scope.row)" v-if="scope.row.isNew" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    export default {
        data () {
            return {
                util: util,
                tableData: [],
                pageParam: {
                    url: this.$Config.apiUrl.electricBillRecordAmmeter,
                    method: "post",
                    params: {
                        startDate: '',
                        endDate: '',
                        projectId: Number(this.$route.query.projectId),
                        ammeterId: '',
                        stationId: ''
                    },
                    freshCtrl: 1,
                },
                optionsStation: {
                    url: this.$Config.apiUrl.getStationList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "stationId",
                    searchKey: "name",
                    pageSize: 100
                },//站点数据
                optionsElectric: {
                    url: this.$Config.apiUrl.electricFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsAmmeter: {
                    url: this.$Config.apiUrl.ammeterFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                chargeFeeType: '',
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tableData.length) return []
                let mergeCols = []
                if(this.chargeFeeType == 1) {
                    mergeCols = ['ammeterId','projectId','stationId','deviceNumId','lastRecordTimeId','lastRecordPowerId','recordTimeId','recordPowerId','intervalPowerId',
                                    'projectId','unitPriceId','intervalIncomeId','lastRemainMoneyId','gradeValueId','intervalRatioId','totalRatioId',
                                    'finalRemainMoneyId','pid'] // 需要合并的列（字段）
                }else {
                    mergeCols = ['ammeterId','projectId','stationId','deviceNumId','lastRecordTimeId','lastRecordPowerId','recordTimeId','recordPowerId','intervalPowerId',
                                    'projectId','unitPriceId','needPayAmountId','projectId','intervalIncomeId','intervalRatioId','totalRatioId','pid'] // 需要合并的列（字段）
                }
                return util.getMergeCells(this.tableData, mergeCols, mergeCols)
            }
        },
        created () {
            this.chargeFeeType = this.$route.query.chargeFeeType
        },
        methods:{
            //获取列表
            setTableData(data) {
                let projectObj = {}
                this.tableData = data.map((item)=>{
                    let tag = '-' + JSON.stringify(item.billId) //每一个项目标识符

                    // 保存每一个项目的每块电表的应结算度数和应付费用
                    if(!projectObj[item.projectId + tag]) {
                        projectObj[item.projectId + tag] = {}
                        projectObj[item.projectId + tag][item.ammeterId] = {
                            intervalPower: item.intervalPower,
                            needPayAmount: item.needPayAmount
                        }
                    }else {
                        if(!projectObj[item.projectId + tag][item.ammeterId]) {
                            projectObj[item.projectId + tag][item.ammeterId] = {
                                intervalPower: item.intervalPower,
                                needPayAmount: item.needPayAmount
                            }
                        }
                    }
                    // 保存每一个项目的每块电表的应结算度数和应付费用  end
                    return {
                        ...item,
                        ammeterId: item.ammeterId + tag,
                        projectId: item.projectId + tag,
                        stationId: item.stationId + tag,
                        deviceNumId: item.ammeterId + tag,
                        lastRecordTimeId: item.projectId + tag,
                        recordTimeId: item.projectId + tag,
                        recordPowerId: item.ammeterId + tag,
                        lastRecordPowerId: item.ammeterId + tag,
                        unitPriceId: item.ammeterId + tag,
                        intervalIncomeId: item.stationId + tag,
                        needPayAmountId: item.ammeterId + tag,
                        lastRemainMoneyId: item.ammeterId + tag,
                        gradeValueId: item.ammeterId + tag,
                        intervalRatioId: item.ammeterId + tag,
                        totalRatioId: item.projectId + tag,
                        finalRemainMoneyId: item.ammeterId + tag,
                        intervalPowerId: item.ammeterId + tag,
                        pid: tag,
                    }
                })

                // 累计每一个项目的每块电表的应结算度数和应付费用
                for (const key in projectObj) {
                    let ite = projectObj[key] // 每一项目下的电表数据
                    let cyIntervalPowerTotal = 0, cyNeedPayAmountTotal = 0
                    for (const k in ite) {
                        const it = ite[k];
                        cyIntervalPowerTotal += it.intervalPower
                        cyNeedPayAmountTotal += it.needPayAmount
                    }
                    projectObj[key]['cyIntervalPowerTotal'] = cyIntervalPowerTotal
                    projectObj[key]['cyNeedPayAmountTotal'] = cyNeedPayAmountTotal
                    
                }

                // 赋值到每一个表格项中
                this.tableData.map(item=>{
                    this.$set(item, 'cyIntervalPowerTotal', projectObj[item.projectId].cyIntervalPowerTotal)
                    this.$set(item, 'cyNeedPayAmountTotal', projectObj[item.projectId].cyNeedPayAmountTotal)
                })
            },
            handleCalculate () {

            },
            handlerRest() {
                this.pageParam.params = {
                    startDate: '',
                    endDate: '',
                    projectId: '',
                    ammeterId: '',
                    stationId: ''
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['electricStationList'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
            finalRemainMoneyClass (row) {
                let value = row.finalRemainMoney || 0
                if(value < 2000) {
                    return 'alertInfoError'
                }else if(value < 5000) {
                    return 'alertInfoWarning'
                }else {
                    return ''
                }
            },
            electricBillDelete (datas) {
                this.$confirm('是否确认删除？','温馨提示')
                .then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.electricBillDelete,
                        method: "post",
                        params: {
                            billId: datas.billId
                        }
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.pageParam.freshCtrl++;
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                })
                .catch(_=>{})
            },
            exportfile () {
                let startDate = this.pageParam.params.startDate || this.$getDay.getTodayBeforeDays(92)
                let endDate = this.pageParam.params.endDate || this.$getDay.getTodayBeforeDays(0)
                this.$exfile({
                    code: 19,
                    fileName: startDate + ' 至 ' + endDate + ' 电费项目站点维度导出统计',
                    startTime: startDate,
                    endTime: endDate,
                    params: {
                        ...this.pageParam.params,
                        startDate: startDate,
                        endDate: endDate
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.s-btn-add{
    width: 135px;
}
/deep/ .s-search-label{
    width: 100px
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
.alertInfoWarning{
    color: #E6A23C;
}
.alertInfoError{
    color: #F56C6C;
}
</style>